export default __webpack_public_path__ + "ff7fb7d3ea9a332e08e3ab9cac7ca3e4.png";